// @ts-nocheck
export const CART_STORAGE_KEY = 'cart-manager:last-cart';

export const saveCartSnapshot = (cart = null) => {
  if (!window?.localStorage) return;
  window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
};

export const readCartSnapshot = () => {
  if (!window?.localStorage) return null;

  const raw = window.localStorage.getItem(CART_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};
